<div class="empty-state">
  <div class="frame-614">
    <h3 class="dialog-message">
      {{ data?.message || 'Do you really want to assign and notify this Load?' }}
    </h3>
  </div>
  <div class="frame-615">
    <button mat-raised-button class="no-button" (click)="onNoClick()">
      No
    </button>
    <button mat-raised-button class="yes-button" (click)="onYesClick()">
      Yes
    </button>
  </div>
</div>

